import { useState } from 'react';
import {
  FaChartBar, FaClipboard, FaClock, FaExclamationTriangle,
  FaChevronLeft, FaChevronRight
} from 'react-icons/fa';
import DashboardPage from './DashboardPage';
import LogProductionFrame1 from './LogProductionFrame1';
import LogProductionFrame2 from './LogProductionFrame2';
import ShiftChange from './ShiftChange';
import ReportIssuModal from "./ReportIssuModal";
import '../../App.css'
export default function DashboardTabs() {
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [selectedMachineId, setSelectedMachineId] = useState(null);
  const [machineName, setMachineName] = useState(null);
  const [machineCode, setMachineCode] = useState(null);
  const [productName, setProductName] = useState(null);
  const [reportIssuModal, setReportIssuModal] = useState(false);
  const storedUser = localStorage.getItem("user");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const name = userData?.user?.name || "Guest";
const currentDate = new Date().toLocaleDateString(undefined, {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
});
  const renderContent = () => {
    switch (activeTab) {
      case "Dashboard":
        return (
          <DashboardPage
            onProcessClick={(processName,machineId,machineName,machineCode,productName) => {
               setSelectedMachineId(machineId);
               setMachineName(machineName);
               setMachineCode(machineCode)
               setSelectedProcess(processName);
               setProductName(productName)
              setActiveTab("Log Production");
            }}
          />
        );

      case "Log Production": {
        if (
          selectedProcess === "injection_molding_type_1" ||
          selectedProcess === "injection_molding_type_2"
        ) {
          return <LogProductionFrame1 machineId={selectedMachineId} machineName={machineName} machineCode={machineCode} productName={productName} />;
        } else {
          return <LogProductionFrame2 machineId={selectedMachineId} machineName={machineName} machineCode={machineCode} productName={productName}/>;
        }
      }

      case "Shift Change":
        return <ShiftChange />;

      default:
        return <DashboardPage />;
    }
  };


  return (
    <div className="container-fluid" style={{ background: "#EEF2F8" }}>
      <div className="row">
        <div className="col-md-1" />
        <div className="col-md-10 mt-5 dashboardTabs">

          {/* Tabs */}
          <div className="d-flex dashboard_tabs rounded text-white px-2 py-1 row  font_family">
            <div className='col-md-3 tabItemCol'><TabItem label="Dashboard" icon={<FaChartBar />}
              active={activeTab === 'Dashboard'}
              onClick={() => setActiveTab('Dashboard')} /></div>
            <div className='col-md-3 tabItemCol'><TabItem label="Log Production" icon={<FaClipboard />}
              active={activeTab === 'Log Production'}
              onClick={() => setActiveTab('Log Production')} /></div>
            <div className='col-md-3 tabItemCol'><TabItem label="Shift Change" icon={<FaClock />}
              active={activeTab === 'Shift Change'}
              onClick={() => setActiveTab('Shift Change')} /></div>
            <div className='col-md-3 tabItemCol'><TabItem label="Report Issues" icon={<FaExclamationTriangle />}
              active={activeTab === 'Report Issues'}
              onClick={() => {
                setActiveTab('Report Issues');
                setReportIssuModal(true);
              }} /></div>
          </div>

          <ReportIssuModal
            show={reportIssuModal}
            handleClose={() => setReportIssuModal(false)}
          />

          {/* Date Header */}
          <div className="row align-items-center mt-5 font_family shiftbox ">
            <div className="col-md-6 col-sm-6">
              <h5 className="mb-0 fw-bold product_machine_name">{currentDate} | {name} </h5>
              <small className="text-muted product_machine_name">Current Shift: Morning Shift</small>
            </div>
            <div className="col-md-6 col-sm-6 text-end todayMargin ">
              <div className="d-inline-flex align-items-center gap-3 product_machine_name">
                <FaChevronLeft style={{ cursor: 'pointer' }} />
                <span className="fw-medium">Today</span>
                <FaChevronRight style={{ cursor: 'pointer' }} />
              </div>
            </div>
          </div>

          <div className="">{renderContent()}</div>
        </div>
        <div className="col-md-1" />
      </div>
    </div>
  );
}

function TabItem({ label, icon, active, onClick }) {
  return (
    <div
      className={`flex-fill text-center py-2 rounded d-flex align-items-center justify-content-center  font_family gap-2 ${active ? 'bg-primary fw-bold' : ''}`}
      style={{ cursor: 'pointer' }}
      onClick={onClick}
    >
      {icon}
      <span>{label}</span>
    </div>
  );
}
